<script>
import AresView from './components/ares-view';

import { querySearch } from '@tencent/nb-h5-tools';
import Auth from '@mixins/auth';
import Base from '@mixins/base';
import Perf from '@/utils/performance';
import { genUUID } from '@/utils/uuid';
import _get from 'lodash/get';
import { reportPageEnter } from '@tencent/nb-web-reporter';

export default {
  mixins: [Auth, Base],
  data() {
    const PreviewTime = Number(querySearch('PreviewTime'));
    return {
      ConfID: querySearch('ConfID'),
      PageID: querySearch('PageID'),
      PackageID: querySearch('PackageID'),
      Version: querySearch('Version'),
      PreviewTime,
      isPreview: Boolean(PreviewTime),
    };
  },
  methods: {
    aresYamlReceived(pageData = {}, pageInfo = {}) {
      // 战神页面特殊性,手动上报页面进入事件
      // 第一个参数为空,事件名报为'page_enter'
      // 这里chaos_cur_spm上报战神页的spm作为第三位埋点,前两位由框架补充
      const ext = JSON.stringify({ // 上报额外参数,需要接受string
        agora_id: _get(pageInfo, 'PageID', ''),
      });
      reportPageEnter('', {
        chaos_cur_spm: `${_get(pageData, 'root.conf.report.spm', '')}`,
        page_name: _get(pageInfo, 'PageID', ''),
        event_uuid: genUUID(),
        ext,
      });
      const pageName = _get(pageInfo, 'Name', '');
      const pageID = _get(pageInfo, 'PageID', '');
      // 使用页面信息设置page, 保证看板上的可读性
      Perf.setConfig({
        page: pageName || pageID ? `${pageName}-${pageID}` : '',
      });
      Perf.firePageComplete();
    },
    aresYamlFail() {
      Perf.setConfig({
        page: window.location.href,
      });
      Perf.firePageComplete();
    },
  },
  render() {
    const { PageID, PackageID, ConfID, Version, PreviewTime, aresYamlReceived, aresYamlFail } = this;

    this.$Logger.sendLogicInfo('ares_h5', '进入 Ares 页面', {
      PageID, PackageID, ConfID, Version, PreviewTime,
      perf: JSON.stringify(window.performance || {}), // 上报页面的 performance 信息
    });

    return <AresView
      aresInfo={{
        PageID, PackageID, ConfID, Version, PreviewTime,
      }}
      aresYamlReceived={aresYamlReceived}
      aresYamlFail={aresYamlFail}
    ></AresView>;
  },
};
</script>
